import { useEffect, useState } from 'react';

/**
 * Хук для оптимистичного отображения значения
 * Задерживает отображение "активного" значения на указанное время
 *
 * @param value - исходное значение
 * @param delay - задержка в миллисекундах
 * @param isActive - функция, определяющая, является ли значение "активным" (по умолчанию проверяет на истинность)
 *
 * @returns оптимистичное значение
 */
export function useOptimisticValue<T>(
  value: T,
  delay: number,
  isActive: (val: T) => boolean = Boolean
): T {
  const [optimisticValue, setOptimisticValue] = useState<T>(value);

  useEffect(() => {
    if (!isActive(value)) {
      setOptimisticValue(value);

      return;
    }

    const timer = setTimeout(() => {
      setOptimisticValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay, isActive]);

  return optimisticValue;
}
